/* import React from "react";
import { graphql, StaticQuery } from "gatsby";
import Img from "gatsby-image";
import DirectionReveal from "direction-reveal";

class Instagram extends React.Component {
  componentDidMount() {
    // Init with all options at default setting
    DirectionReveal({
      selector: ".direction-reveal", // Container element selector.
      itemSelector: ".direction-reveal__card", // Item element selector.
      animationName: "slide", // Animation CSS class.
      enableTouch: true, // Adds touch event to show content on first click then follow link on the second click.
      touchThreshold: 250, // Touch length must be less than this to trigger reveal which prevents the event triggering if user is scrolling.
    });
  }

  render() {
    const {
      data: {
        allInstaNode: { edges: posts },
      },
    } = this.props;

    // console.log(this.props.data.wordPress.caseStudies.edges);

    return (
      <section className="p-top p-bottom bg-light-gray" id="instagram">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 className="text-center">Instagram</h2>
              <div className="row no-gutters direction-reveal direction-reveal--grid-bootstrap direction-reveal--demo-bootstrap grid">
                {posts &&
                  posts.map((item, index) => {
                    return (
                      <div className="col-md-3 post" key={index}>
                        {item && item.node && (
                          <>
                            <a
                              target="_blank"
                              className="direction-reveal__card"
                              href={`https://www.instagram.com/p/${item.node.id}`}
                              rel="noopener noreferrer"
                            >
                              <Img
                                alt={item.node.caption}
                                fixed={
                                  item.node.localFile.childImageSharp.fixed
                                }
                              />
                              {item.node.caption && (
                                <span className="direction-reveal__overlay direction-reveal__anim--in">
                                  <h5 className="direction-reveal__title">
                                    {item.node.caption}
                                  </h5>
                                </span>
                              )}
                            </a>
                          </>
                        )}
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default () => (
  <StaticQuery
    query={graphql`
      {
        allInstaNode {
          edges {
            node {
              caption
              preview
              id
              localFile {
                childImageSharp {
                  fixed(width: 315, height: 315) {
                    ...GatsbyImageSharpFixed_withWebp
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={(data) => <Instagram data={data} />}
  />
);
 */

function Instagram() {
  return '';
}
export default Instagram;
